import React from 'react'
import { Grid, Icon, Tooltip, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'

export const HeadCell = ({ alias, tooltip = true }) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()
  return (
    <Grid wrap={false} fluid={false} gap={8} alignItems={'center'} justifyContent={'start'}>
      <Typography
        component={'span'}
        variant={breakpoints.fbs ? 'Body-10' : 'Body-15'}
        color={'Label-Secondary'}
      >
        {t(`referral::referral_links_create.table.heading.${alias}.label`)}
      </Typography>
      {tooltip && (
        <Tooltip
          title={t(`referral::referral_links_create.table.heading.${alias}.tooltip`)}
          textAlign={'center'}
        >
          <Icon size={'sm'} name={'information'} color={'Interface-Seventh'} />
        </Tooltip>
      )}
    </Grid>
  )
}

HeadCell.propTypes = {
  alias: PropTypes.string,
  tooltip: PropTypes.bool,
}
